const getOrderProductRowKey = (product) => {
  const bundleId = product.bundle_id || 'no-bundle';
  const rowId = product.id || product.product_id || 'no-row-id';
  const productId = product.product_id || product.id || 'no-product-id';
  const productClass = product.class || product.cart_type || 'no-class';

  return `${bundleId}:${rowId}:${productId}:${productClass}`;
};

export default getOrderProductRowKey;
